import { render, staticRenderFns } from "./RecommendFirst.vue?vue&type=template&id=4703804a&"
import script from "./RecommendFirst.vue?vue&type=script&lang=js&"
export * from "./RecommendFirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports